import { ROUTE } from '@config/navigation';
import { STEP } from '@types';

export const convertStepToRoute = (step: STEP): ROUTE => {
  switch (step) {
    case STEP.DONATION:
      return ROUTE.DONATION;

    case STEP.SUPPORTER:
      return ROUTE.SUPPORTER;

    case STEP.PAYMENT:
      return ROUTE.PAYMENT;

    case STEP.THANK_YOU:
      return ROUTE.THANK_YOU;

    default:
      throw new Error('Invalid step');
  }
};

export const convertRouteToStep = (route: ROUTE): STEP => {
  switch (route) {
    case ROUTE.DONATION:
      return STEP.DONATION;
    case ROUTE.SUPPORTER:
      return STEP.SUPPORTER;
    case ROUTE.PAYMENT:
      return STEP.PAYMENT;
    case ROUTE.THANK_YOU:
      return STEP.THANK_YOU;
    default:
      throw new Error(`Invalid route. Cannot process ${route}`);
  }
};
